import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  LEAVE_APPLICATION_NOT_FOUND: 'Leave application was not found.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Check the entered leave information.',
  LEAVE_DURATION_REQUIRED: 'Enable full-day or half-day leave for this leave type.',
  LEAVE_CARRY_FORWARD_INVALID:
    'Carry forward settings are invalid. Turn carry forward on or off, and use a maximum between 0 and 365 days or leave it blank for no limit.',
  LEAVE_TYPE_RETIRED: 'This leave type has been retired and cannot be created again.',
  LEAVE_CONFIGURATION_LOAD_FAILED:
    'Leave configuration was saved but could not be loaded. Pull to refresh the list.',
  INVALID_DATE_RANGE: 'The selected date range is invalid.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
  EMPLOYEE_PROFILE_REQUIRED: 'An employee profile is required for leave.',
  LEAVE_DATE_OVERLAP: 'An overlapping leave application already exists.',
  LEAVE_POLICY_NOT_ASSIGNED:
    'This leave type is not assigned to you. Contact HR Admin.',
  LEAVE_POLICY_CHANGED:
    'Your leave policy was changed by HR Admin. Your balances have been refreshed; review and apply again.',
};

export function leaveErrorMessage(
  error: unknown,
  fallback = 'Unable to load leave information.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    const message =
      'message' in error && typeof (error as { message?: unknown }).message === 'string'
        ? (error as { message: string }).message.trim()
        : '';
    if (
      (code === 'VALIDATION_ERROR' || code === 'LEAVE_DURATION_REQUIRED' || code === 'BUSINESS_RULE_ERROR')
      && message
    ) {
      return message;
    }
    if (MESSAGES[code] && code !== 'VALIDATION_ERROR') return MESSAGES[code];
    if (MESSAGES[code] && !message) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (
    (apiError.code === 'VALIDATION_ERROR'
      || apiError.code === 'LEAVE_DURATION_REQUIRED'
      || apiError.code === 'BUSINESS_RULE_ERROR')
    && apiError.message?.trim()
  ) {
    return apiError.message.trim();
  }
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  if (apiError.message?.trim()) {
    return apiError.message.trim();
  }
  return fallback;
}
